




















































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { DropdownOption } from '@/models/swine/dropdown.model';
import { generateUniqueId } from '@/utils/lodash';

@Component({})
export default class AnalysisDropdown extends Vue {
  isActive = false;
  selected: DropdownOption | null = null;

  @Prop({
    type: Boolean,
    default: false,
  })
  disabled!: boolean;

  @Prop({
    type: Number,
    default: 0,
  })
  totalCount!: number;

  @Prop({
    type: Number,
    default: 0,
  })
  startPaginationCount!: number;

  @Prop({
    type: Number,
    default: 0,
  })
  endPaginationCount!: number;

  @Prop({
    type: Array,
    default: [],
    required: true,
  })
  options!: DropdownOption[];

  @Prop()
  selectedOption!: DropdownOption | string;

  @Prop()
  textValue!: string;

  stringQuery = '';

  @Emit('select')
  handleSelected(data: DropdownOption) {
    this.selected = data;
    this.isActive = false;
    return data;
  }

  @Emit(`search`)
  returnSearchQuery() {
    return this.stringQuery;
  }

  @Emit('pageNumber')
  increasePageNumber() {
    return 1;
  }

  @Emit('pageNumber')
  decreasePageNumber() {
    return -1;
  }

  @Watch('selectedOption')
  updateSelectedOption() {
    if (this.selectedOption) {
      if (typeof this.selectedOption !== 'string') {
        this.selected = this.selectedOption;
        this.handleSelected(this.selected);
      } else {
        const selectedOption = this.options.filter(
          (option) => option.value === this.selectedOption,
        );
        if (selectedOption[0]) {
          this.selected = selectedOption[0];
          this.handleSelected(this.selected);
        }
      }
    }
  }

  created() {
    if (this.selectedOption && this.selectedOption !== '') {
      this.updateSelectedOption();
    } else {
      this.initializeDefaultOption();
    }
  }

  initializeDefaultOption() {
    if (this.selectedOption && this.selectedOption.constructor === Object) {
      this.selected = this.selectedOption as DropdownOption;
    } else {
      const option = this.options.find((el) => {
        el.value === this.selectedOption;
      });
      if (option) {
        this.selected = option;
      } else {
        // Set a default value
        this.selected = {
          text: `Select Report`,
          value: ``,
          uniqueKey: generateUniqueId('report_selection'),
        };
      }
    }
  }
}
